module.exports = __webpack_public_path__ + "img/8dcd0d89d526385dc5108ee947a7fbd.9a8edd1c.jpg";